import Config from '@/config';
import {
    contextParams,
    isRouteSomeTask,
    isTaskDone,
    isTaskStageItemDone,
    routeToTaskStageItem,
    TABS
} from "@/utils/task";
import Vue from "vue";
import {end} from "@/utils/string";
import {date2Iso, iso2DDMMYYYY} from "@/utils/date";
import router from "@/router";

const actions = {
    create(store, params) {
        return store.dispatch('post', {
            action: 'task-create',
            params
        }, {root: true})
            .catch((error) => {
                //this.error = error?.message || error || 'Не получилось';
            }).finally(() => {
                store.state.isSending = false;
            });
    },
    /**
     * Fetches list of messages for specified task.
     * @param store
     * @param params
     * @returns {*}
     */
    /*msgs(store, params) {
        return store.dispatch('get', {
            action: 'task/msgs',
            params
        }, {root: true});
    },*/
    /**
     * @deprecated todo should be used via "action"
     * @param store
     * @param params
     * @returns {*}
     */
    update(store, params) {
        console.log("@deprecated ACTION task/update", params);

        // local change
        store.commit("taskUpdate", params, {root: true});

        // remote change
        return store.dispatch('post', {
            action: 'task/update',
            params
        }, {root: true});
    },
    /**
     * Toggles task "done" status.
     * @param store
     * @param item
     * @param forceValue
     * @returns {Promise<*>}
     */
    async toggleDone(store, {item, forceValue},) {
        let params, res;
        if (forceValue === true || !isTaskDone(item)) {
            // task is done
            params = {
                //isDone: true,
                doneAt: date2Iso(new Date()),
                isActive: false,
            }
        } else {
            // task is undone
            params = {
                //isDone: false,
                isActive: true,
                doneAt: null
            };
        }

        return store.dispatch("action", {
            action: "task/update",
            params: {
                taskId: item.id,
                params,
                with1TaskChecking: true,
            }
        }, {root: true});
    },
    /**
     * Toggles "done" at specified stage of the current task.
     * @param store
     * @param stage
     * @param forceValue
     * @returns {Promise<*>}
     */
    async toggleStageDone(store, {taskId, contentId, forceValue}) {
        if (!store.rootState.page.task.item?.id) return;
        if (!store.rootState.page.task.stages?.length) return;

        let params;

        const stageItem = store.rootState.page.task.stages.find(el => el.contentId === contentId);
        if (forceValue === true || !isTaskStageItemDone(stageItem))
            params = {
                stageDoneAt: date2Iso(new Date()),
            };
        else {
            params = {
                stageDoneAt: null,
            };
        }

        return store.dispatch("action", {
            action: "task/updateStage",
            params: {
                taskId,
                contentId,
                params,
                with1TaskChecking: true,
            }
        }, {root: true});
    },

    /*assign(store, params) {
        console.log("ACTION task/assign", params);

        // local change
        store.commit("taskAssign", params, {root: true});

        // remote change
        return store.dispatch('post', {
            action: 'task/assign',
            params
        }, {root: true});
    },
    /!**
     * @deprecated not used, moved to action
     * @param store
     * @param params
     * @returns {*}
     *!/
    delete(store, params) {
        console.log("ACTION task/delete", params);

        // local change
        store.commit("taskDelete", params, {root: true});

        // remote change
        return store.dispatch('post', {
            action: 'task/delete',
            params
        }, {root: true});
    },*/
    menu(store, params) {
        return store.commit('uiMenu', {
            menu: store.rootState.ui.taskMenu,
            params
        }, {root: true});
    },
    subtasksMenu(store, params) {
        return new Promise((resolve) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.taskSubtasksMenu,
                params
            }, {root: true});
        });
    },
    stageMenu(store, params) {
        return store.commit('uiMenu', {
            menu: store.rootState.ui.taskStageMenu,
            params
        }, {root: true});
    },
    /**
     * Useful wrapper around ui/dialog to update a task:
     * 1. dispatches ui/dialog
     * 2. dispatches task/update
     * @param store
     * @param params
     * @returns {Promise<unknown>}
     */
    async dialog(store, params) {
        console.log("task/dialog", params?.dialog);
        return new Promise((resolve, reject) => {
            store.dispatch("ui/dialog", params, {root: true})
                .then(res => {
                    //console.log("RES task/dialog", res, params);
                    if (params?.skipUpdateAction) resolve(res);
                    else if (res) {
                        store.dispatch("task/update", {
                            taskId: params.item.id,
                            params: res,
                            with1TaskChecking: true,
                        }, {root: true}).then((response) => {
                            // __response carries the raw WS/HTTP response (with result.next1Task - see
                            // CommandInvocation.with1TaskChecking) for make1TaskProgress() callers
                            resolve({...res, __response: response});
                        });
                    } else reject();
                }).catch(() => reject());
        });
    },
    /*async dialogDefer(store, params) {
        return new Promise((resolve, reject) => {
            store.dispatch("ui/dialogTaskDone", params, {root: true}).then(res => {
                //console.log("RES", res);
                if (res?.doneAt) {
                    store.dispatch("task/update", {
                        taskId: params.item.id,
                        params: res
                    }, {root: true}).then(()=>{
                        resolve(res);
                    });
                }
                else reject();
            });
        });
    },*/
    /*async dialogDone(store, params) {
        return new Promise((resolve, reject) => {
            store.dispatch("ui/dialogTaskDone", params, {root: true}).then(res => {
                //console.log("RES", res);
                if (res?.doneAt) {
                    store.dispatch("task/update", {
                        taskId: params.item.id,
                        params: res
                    }, {root: true}).then(()=>{
                        resolve(res);
                    });
                }
                else reject();
            });
        });
    },
    async dialogDelay(store, params) {
        const res = await store.dispatch("ui/dialogDelay", params, {root: true});
        //console.log("RES", res);
        if (params?.item?.id) {
            store.dispatch("task/update", {
                taskId: params.item.id,
                params: res
            }, {root: true});
        }
    },
    */
    /*async dialogTaskDeadline(store, params) {
        return new Promise((resolve, reject) => {
            store.dispatch("ui/dialogTaskDeadline", params, {root: true})
                .catch(() => reject());
            //console.log("RES", res);
            if (res) {
                if (params?.item?.id) {
                    store.dispatch("task/update", {
                        taskId: params.item.id,
                        params: res
                    }, {root: true});
                }
            }
        });
    },*/
    async dialogMove(store, params) {
        return new Promise(async (resolve, reject) => {
            const res = await store.dispatch("ui/dialogMove", params, {root: true});
            //console.log("task/dialogMove AFTER ui/dialogMove RES", res);
            if (params?.items?.length) {
                if (params.place) {
                    await store.dispatch("action", {
                        action: "task/place",
                        params: {
                            ...res
                        }
                    }, {root: true});
                } else {
                    await store.dispatch("action", {
                        action: "task/move",
                        params: {
                            ...res
                        }
                    }, {root: true});
                }
            }
            resolve(res);
        });
    },
    /*async dialogFolderIMView(store, params) {
        return new Promise((resolve, reject) => {
            params.callback = (res) => {
                return resolve(res);
            };

            store.commit('uiMenu', {
                menu: store.rootState.ui.assigneeMenu,
                params
            }, {root: true});
        });
    },*/
    dialogTemplate(store, params) {
        if (!params?.item?.id) return;
        return new Promise((resolve, reject) => {
            //console.log("dialogTemplate", params);
            store.rootState.ui.dialogTaskTemplate.item = params.item;
            store.rootState.ui.dialogTaskTemplate.callback = (res) => {
                store.dispatch("action", {
                    action: "task/update",
                    params: {
                        taskId: params.item.id,
                        params: res,
                    },
                }, {root: true});

                //console.log("TEMPLATE SAVED", resSaved);
                // switch to templates tab
                //store.rootState.page.context.tab = TABS.TEMPLATES;
                //store.commit("uiRouteToTab", TABS.TEMPLATES, {root: true});

                return resolve(res);
            };
            store.rootState.ui.dialogTaskTemplate.isVisible = true;
        });
    },
    dialogMakeTopic(store, params) {
        if (!params?.item?.auth) return;
        return new Promise((resolve, reject) => {
            //console.log("dialogTemplate", params);
            store.rootState.ui.dialogTaskMakeTopic.item = params.item;
            store.rootState.ui.dialogTaskMakeTopic.callback = (res) => {
                router.push({
                    name: "context",
                    params: {
                        contextId: res.contextId
                    }
                });

                return resolve(res);
            };
            store.rootState.ui.dialogTaskMakeTopic.isVisible = true;
        });
    },
    dialogLinkThread(store, params) {
        if (!params?.item?.id) return;
        return new Promise((resolve, reject) => {
            store.rootState.ui.dialogTaskLinkThread.item = params.item;
            store.rootState.ui.dialogTaskLinkThread.callback = (res) => resolve(res);
            store.rootState.ui.dialogTaskLinkThread.isVisible = true;
        });
    },
    group(store, params) {
        console.log("ACTION task/group", params);

        // local change
        store.commit("taskGroup", params, {root: true});

        // remote change
        return store.dispatch('post', {
            action: 'task/group',
            params,
        }, {root: true});
    },

    // TODO REVIEW ---------------

    refetch(store, params) {
        return store.dispatch('get', {
            action: 'task-item', params: {
                auth: store.rootState.page?.todo?.item?.auth,
            }
        }, {root: true})
            .then(result => {
                store.commit('setPage', result, {root: true});
                return result;
            })
            .catch((error) => {
                //this.error = error?.message || error || 'Не получилось';
            });
    },
    refetchWithGroup(store, params) {
        return store.dispatch('get', {
            action: 'group-item,task-item', params: {
                todoAuth: store.rootState.page?.todo?.item?.auth,

                auth: store.rootState.page?.group?.group?.auth,
                topicAuth: store.rootState.page?.group?.topic?.auth,
                tab: store.rootState.page?.group?.tab,
                assigneeAuth: store.rootState.page?.group?.assignee?.id,
                prio: store.rootState.page?.group?.prio,
                search: store.rootState.ui.search.value,
            }
        }, {root: true})
            .then(result => {
                store.commit('setPage', result, {root: true});
                return result;
            })
            .catch((error) => {
                //this.error = error?.message || error || 'Не получилось';
            });
    },

    sort(store, params) {

        return store.dispatch('post', {
            action: 'group-task-sort',
            params
        }, {root: true}).then((res) => {
            return res;
        }).catch((error) => {
            //this.error = error?.message || error || 'Не получилось';
        }).finally(() => {
        });
    },
};

export default actions;
